module.exports = __webpack_public_path__ + "assets/chevronRight-abd153.svg";